import React, { useContext, useEffect } from "react";
import * as Dati from "src/Dati";
import useReducerOnChange from "src/hooks/ReducerOnChange";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { Trad } from "src/components/";
import { _ButtonAPI, _CommissionsTab, _TabbedForm } from "..";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

export enum CopyType {
    Branch = "ID_TipoRamo",
    Product = "ID_TipoProdotto",
    Company = "ID_BinderCompagnia",
    EmptyFields = ""
}

export interface IProvvigioniProduct extends Dati.CProvvigioni {
    Index: number;
}

interface IBondsRatesFormProps {
    ID_Binder: string;
}

export const _CommissionsForm: React.FC<IBondsRatesFormProps> = ({ ID_Binder }) => {
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Data, setData] = useReducerOnChange<Dati.CProvvigioni[]>([]);

    useEffect(() => {
        GetData();
    }, [ID_Binder]);

    const OnApiError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    const GetData = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Provvigione?id_Binder=${ID_Binder}`,
            OnRis: OnGetData,
            OnErrore: (sender: ChiamaWeb, error: Error) => OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetData = (sender: ChiamaWeb, data: Dati.CRisAPIProvvigioni) => {
        setData({ Type: "Set", Value: SortProducts(data?.Dati) });
    };

    const SortProducts = (data: Dati.CProvvigioni[]): Dati.CProvvigioni[] => data.sort((a, b) => a.ID_BinderCompagnia - b.ID_BinderCompagnia || a.ID_TipoProdotto - b.ID_TipoProdotto);

    const OnClickSave = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("STATI ERRORE", data.ErrTesto, "error");
        } else {
            ShowDialog("PROVVIGIONI", Trad.Trad("ProvvigioniAggiornateCorrettamente"), "success");
        }
    };

    const GetGroupedData = (): IProvvigioniProduct[][] =>
        Data.reduce((total: any, current, index) => {
            let last = total[total.length - 1];

            if (!last || last[0].ID_BinderCompagnia !== current.ID_BinderCompagnia) {
                total.push([{ ...current, Index: index }]);
            } else {
                last.push({ ...current, Index: index });
            }

            return total;
        }, []);

    const CopyToEmptyFields = (valueToCopy: [], item: Dati.CProvvigioni): Dati.CProvvigioni => {
        const itemCommissionData: [] = JSON.parse(item.ProvvigioniJSON);

        itemCommissionData.map((el: any) => {
            const commissionType = Object.keys(el.Parametri)[0];

            if (!el.Parametri[commissionType]) {
                valueToCopy.forEach((val: any) => {
                    if (Object.keys(val.Parametri)[0] == commissionType) {
                        el.Parametri[commissionType] = val.Parametri[commissionType];
                        el.Funzione = val.Funzione;
                    }
                });
            }
        });
        item.ProvvigioniJSON = JSON.stringify(itemCommissionData);

        return item;
    };

    const OnCopyValues = (copiedItemIndex: number) => (type: CopyType): any => {
        let copiedValues: Dati.CProvvigioni[] = Data;
        const valueToCopy = JSON.parse(Data[copiedItemIndex].ProvvigioniJSON);

        copiedValues = copiedValues.map(item => {
            if (!type && item.ProvvigioniJSON != "{}") {
                CopyToEmptyFields(valueToCopy, item);
            }
            if (type && item[type] === copiedValues[copiedItemIndex][type]) {
                item.ProvvigioniJSON = copiedValues[copiedItemIndex].ProvvigioniJSON;
            }
            return item;
        });
        setData({ Type: "Set", Value: copiedValues });
    };

    const groupedData = GetGroupedData();

    return groupedData.length > 0 ? (
        <_TabbedForm
            Actions={[<_ButtonAPI Default Attivo Testo={Trad.Trad("Salva")} URL="/api/Provvigione" ParamCorpo={Data} OnClick={OnClickSave} OnErrore={OnApiError} />]}
            RenderTabContent={(index: number) => (
                <_CommissionsTab OnCopyValues={OnCopyValues} Products={groupedData[index]} OnChange={(e, val) => setData({ Type: "OnChangeFromValue", Name: e, Value: val })} />
            )}
            TabLabels={groupedData.map(group => group[0].DenominazioneCompagnia)}
        />
    ) : null;
};



// WEBPACK FOOTER //
// ./src/inar2/components/Commissions/CommissionsForm.tsx